const aboutConfig = {
  meta: {
    title: "Over Mission Movement | Militaire Ervaring & Coaching sinds 2014",
    description:
      "Lees het verhaal achter Mission Movement, opgericht door Justin Peeters: voormalig marinier, gecertificeerd coach en specialist in voorbereiding richting Defensie en veiligheidsdiensten.",
    ogTitle: "Over Mission Movement | Militaire Ervaring & Coaching sinds 2014",
    ogDescription:
      "Lees het verhaal achter Mission Movement, opgericht door Justin Peeters: voormalig marinier, gecertificeerd coach en specialist in voorbereiding richting Defensie en veiligheidsdiensten.",
    ogImage: "https://missionmovement.nl/img/thestory.png",
    ogUrl: "https://missionmovement.nl/about",
    canonical: "https://missionmovement.nl/about",
  },
  hero: {
    title: "Het verhaal achter Mission Movement",
    subtitle:
      "Mission Movement is ontstaan uit wat ik zelf heb gezien in opleiding, operatie en coaching: motivatie is vaak niet het probleem. De juiste voorbereiding wel.",
    backgroundClass: "bg-parajumping bg-bottom bg-no-repeat bg-cover",
  },
foundations: {
  // heading: "Grondslagen",
  subheading: "Waarom Mission Movement bestaat",
  body: `Sommige carrières vragen meer dan motivatie.

Richting Defensie of de veiligheidsdiensten werken betekent dat je lichaam, je hoofd en je belastbaarheid onderdeel worden van je voorbereiding. Zoals je voor andere beroepen serieus moet leren, moet je voor dit werk serieus bouwen aan je fysieke en mentale basis.

Mission Movement is ontstaan uit ervaring. Uit wat ik zelf heb meegemaakt, maar ook uit wat ik van dichtbij heb gezien bij anderen: gemotiveerde mensen die hard werkten en vooral gebaat waren bij structuur, begeleiding en een realistische opbouw die aansloot op wat er werkelijk gevraagd werd.

Ik weet hoe groot het verschil kan zijn wanneer voorbereiding, begeleiding en belastbaarheid wel goed samenkomen.

Dat raakt me. Omdat deze beroepen voor veel mensen niet zomaar een baan zijn. Het zijn richtingen waar je bewust voor kiest. Werk dat discipline, verantwoordelijkheid, kameraadschap en mentale hardheid vraagt. Voor mij behoren het tot de mooiste beroepen die er bestaan.

Juist daarom vind ik dat kandidaten een eerlijke kans verdienen om goed voorbereid te starten.

Niet alleen om een test of selectie te halen, maar vooral om de fase daarna aan te kunnen: de opleiding, de dagelijkse belasting, de druk, de vermoeidheid en uiteindelijk het werk zelf.

Mission Movement is een Nederlands voorbereidingsplatform voor kandidaten richting Defensie, politie, brandweer, KMar en specialistische eenheden. Het is gebouwd voor mensen die niet zomaar willen trainen, maar serieus voorbereid aan hun traject willen beginnen.

We maken duidelijk waar je nu staat, wat er nodig is en hoe je daar gericht naartoe werkt.

Het doel is niet alleen om door een selectie heen te komen. Het doel is om met een sterke basis te starten aan de carrière waar je serieus voor kiest.`,
},
  quote: {
    backgroundClass: "bg-heigendhert",
    text: "Discipline is de brug tussen doelen en verwezenlijking.",
  },
  missionValues: {
    heading: "Missie & Waarden",
    missionTitle: "Onze Missie:",
    missionBody:
      `Mission Movement helpt je richting Defensie en veiligheidsdiensten bouwen aan een sterke fysieke en mentale basis.

Niet alleen om een norm te halen, maar om voorbereid te starten aan de fase daarna: opleiding, werkdruk, herhaling, vermoeidheid en verantwoordelijkheid.

Onze aanpak richt zich op belastbaarheid, discipline, techniek, herstelvermogen, mentale weerbaarheid en consistente uitvoering over langere tijd.

Het doel is helder: zorgen dat je niet alleen fitter wordt, maar beter voorbereid bent op wat het werk daadwerkelijk vraagt.`,
    valuesTitle: "Kernwaarden:",
    values: [
      {
        label: "Discipline",
        text: `Geen afhankelijkheid van motivatie.
Wel structuur, gewoontes en verantwoordelijkheid nemen voor je eigen proces.`,
      },
      {
        label: "Vastberadenheid",
        text: `Vooruitgang komt niet vanzelf. Je verschijnt, je doet het werk en je leert omgaan met dagen waarop het minder vanzelf gaat.`,
      },
      {
        label: "Belastbaarheid",
        text: `Fit zijn is niet genoeg. Je lichaam moet voorbereid worden op herhaling, volume, impact, vermoeidheid en herstel.`,
      },
            {
        label: "Duidelijkheid",
        text: `Elke training heeft een functie binnen de grotere opbouw. Je moet weten waar je aan werkt, waarom je het doet en hoe het bijdraagt aan je doel.`,
      },
              {
        label: "Duurzaamheid",
        text: `Het doel is niet om jezelf kapot te trainen. Het doel is om sterker, slimmer en beter voorbereid aan je traject te beginnen.`,
      },
    ],
    outro:
      "Deze waarden vormen het fundament van onze aanpak - gericht op duurzame, mentale én fysieke voorbereiding.",
  },
 closingCta: {
  heading: "Wat wordt jouw rol?",
  body: `Veel mensen praten over verandering. Minder mensen bouwen er daadwerkelijk naartoe.

Als jij serieus richting Defensie of veiligheidsdiensten wilt werken, begint voorbereiding niet pas bij de selectie. Het begint nu, met structuur, discipline en een duidelijk plan.

Mission Movement helpt je die basis opbouwen.`,
  buttonText: "Start je voorbereiding",
  buttonLink: "/pricing",
},
  endDivider: {
    backgroundClass: "bg-friscatnight",
  },
};

export default aboutConfig;
